// <purpose>Selection-driven list:detail flex-grow ratio for ArchivSeite's row (non-compact) layout.
// Browsing (nothing selected) → list-dominant 2:1; reading a selected ticket → detail-dominant 1:2.
// See spec 2026-06-16-archivseite-listdetail-morph-design.md.</purpose>
export function listDetailFlex(selectedUuid: string | null): { list: number; detail: number } {
  return selectedUuid ? { list: 1, detail: 2 } : { list: 2, detail: 1 };
}
